<template>
  <span class="pl-2">
    <span v-if="icon === 'info'">
      <v-icon
        small
        color="blue"
        @click.stop.prevent="html ? (showPopup = !showPopup) : null"
        :title="hoverText"
        >fas fa-info-circle</v-icon
      >
    </span>
    <span
      v-if="icon === 'new'"
      :title="hoverText"
      class="ml-1 btn btnNew"
      @click.stop.prevent="html ? (showPopup = !showPopup) : null"
    >
      New
    </span>
    <span
      v-if="icon === 'beta'"
      :title="hoverText"
      class="ml-1 btn btnBeta"
      @click.stop.prevent="html ? (showPopup = !showPopup) : null"
    >
      Beta
    </span>
    <span
      v-if="icon === 'legacy'"
      :title="hoverText"
      class="ml-1 px-1 btn btnLegacy"
    >
      Legacy
    </span>
    <v-dialog v-model="showPopup" color="white" width="600">
      <v-card>
        <v-card-text>
          <p class="pt-4" v-html="html"></p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="primary"
            style="margin: auto;"
            text
            @click="showPopup = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
export default {
  name: "SelectorButtonIcon",
  props: {
    icon: {
      type: String,
      validator: (value) => {
        return ["new", "beta", "info", "legacy"].indexOf(value) !== -1;
      },
    },
    html: {
      type: String,
    },
    hoverText: {
      type: String,
    },
  },
  data() {
    return {
      showPopup: false,
    };
  },
};
</script>

<style scoped>
.btn {
  padding: 2px;
  color: white;
  border-radius: 4px;
  font-size: x-small;
  margin-left: -5px;
  position: relative;
  top: -2px;
}
.btnNew {
  background-color: #00ae42;
}
.btnBeta {
  background-color: #f71f1f;
}
.btnLegacy {
  background-color: #ff9463;
}
</style>
